"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNotificationSettingsUrl = void 0;
const notification_support_1 = require("./notification-support");
/**
 * Returns the special URL that leads to the Notifications settings in the
 * current OS. On Windows, this is only available on versions 10+.
 */
function getNotificationSettingsUrl() {
    if (!notification_support_1.supportsNotifications()) {
        return null;
    }
    return process.platform === 'darwin'
        ? 'x-apple.systempreferences:com.apple.preference.notifications'
        : 'ms-settings:notifications';
}
exports.getNotificationSettingsUrl = getNotificationSettingsUrl;
//# sourceMappingURL=notification-settings-url.js.map